<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>

  <form class="form" [formGroup]="allergyEditForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>

      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <ul>
          <li *ngFor="let msg of submissionErrorObj">{{ msg.details | translate }}</li>
        </ul>
      </kt-alert>

      <div class="form-group row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <h4>{{ 'ALLERGY.INPUT.BASIC' | translate }}</h4>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.CODE">Code</mat-label>
            <input
              matInput
              [matAutocomplete]="auto"
              (ngModelChange)="codeInputChanged(codeInput.value)"
              #codeInput
              formControlName="code"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #auto="matAutocomplete"
              (optionSelected)="selectedCode($event)"
            >
              <!--  [displayWith]="displayFnCode" -->
              <mat-option *ngFor="let code of filteredCode | async" [value]="code">
                {{ code.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('code', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.CLINICAL_STATUS">Clinical status</mat-label>
            <mat-select formControlName="clinicalStatus">
              <mat-option value="active">Active</mat-option>
              <mat-option value="inactive">Inactive</mat-option>
              <mat-option value="resolved">Resolved</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('clinicalStatus', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.VERIFICATION_STATUS">Verification status</mat-label>
            <mat-select formControlName="verificationStatus">
              <mat-option value="unconfirmed">Unconfirmed</mat-option>
              <mat-option value="confirmed">Confirmed</mat-option>
              <mat-option value="refuted">Refuted</mat-option>
              <mat-option value="entered-in-error">Entered in Error</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('verificationStatus', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-label class="label-radio-button" translate="ALLERGY.INPUT.TYPE">Type</mat-label>
          <br />
          <mat-radio-group formControlName="type">
            <mat-radio-button value="allergy">Allergy </mat-radio-button>
            <mat-radio-button value="intolerance">Intolerance</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="col-lg-8 kt-margin-bottom-20-mobile">
          <mat-label class="label-radio-button" translate="ALLERGY.INPUT.CRITICALITY"
            >criticality</mat-label
          >
          <br />
          <mat-radio-group formControlName="criticality">
            <mat-radio-button value="low">Low</mat-radio-button>
            <mat-radio-button value="high">High</mat-radio-button>
            <mat-radio-button value="unable-to-assess">Unable to access</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-lg-8 kt-margin-bottom-20-mobile headers-in-post-allergy">
          <table>
            <tr>
              <td>
                <mat-label class="label-radio-button" translate="ALLERGY.INPUT.CATEGORY"
                  >category</mat-label
                >
              </td>
            </tr>
            <tr>
              <td *ngFor="let cat of categories; let i = index">
                <div class="labels-of-checkbox">
                  <label>
                    <input type="checkbox" [value]="cat.value" (change)="onCatChange($event)" />
                    {{ cat.description }}
                  </label>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile headers-in-post-allergy">
          <h4>{{ 'ALLERGY.INPUT.ON_SET' | translate }}</h4>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.ONSET_TYPE">Onset Type</mat-label>
            <mat-select
              formControlName="onset_type"
              #ty
              (ngModelChange)="chooseOnsetType(ty.value)"
            >
              <mat-option value="dateTime">Date</mat-option>
              <mat-option value="string">Text</mat-option>
              <mat-option value="Period">Period</mat-option>
              <mat-option value="Age">Age</mat-option>
              <mat-option value="Range">Range</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('onset_type', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'dateTime'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="onsetDate" formControlName="onsetDate" />
            <mat-datepicker-toggle matSuffix [for]="onsetDate"></mat-datepicker-toggle>
            <mat-datepicker #onsetDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'string'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_STRING' | translate }}</mat-label>
            <input matInput formControlName="onsetString" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Period'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_PERIOD_START' | translate }}</mat-label>
            <input matInput [matDatepicker]="onsetPeriodStart" formControlName="onsetPeriodStart" />
            <mat-datepicker-toggle matSuffix [for]="onsetPeriodStart"></mat-datepicker-toggle>
            <mat-datepicker #onsetPeriodStart></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Period'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_PERIOD_END' | translate }}</mat-label>
            <input matInput [matDatepicker]="onsetPeriodEnd" formControlName="onsetPeriodEnd" />
            <mat-datepicker-toggle matSuffix [for]="onsetPeriodEnd"></mat-datepicker-toggle>
            <mat-datepicker #onsetPeriodEnd></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Age'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_AGE' | translate }}</mat-label>
            <input matInput type="number" formControlName="onsetAge" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Age'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_AGE_UNIT' | translate }}</mat-label>
            <mat-select formControlName="onsetAgeUnit">
              <mat-option value="a">Year</mat-option>
              <mat-option value="mo">Month</mat-option>
              <mat-option value="wk">Week</mat-option>
              <mat-option value="d">Day</mat-option>
              <mat-option value="h">Hour</mat-option>
              <mat-option value="min">Minutes</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Range'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_RANGE_LOW' | translate }}</mat-label>
            <input matInput formControlName="onsetRangeLow" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Range'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET_RANGE_HIGH' | translate }}</mat-label>
            <input matInput formControlName="onsetRangeHigh" />
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile headers-in-post-allergy">
          <h4>{{ 'ALLERGY.INPUT.RECORDING' | translate }}</h4>
        </div>

        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.RECORDED_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="recordedDate" formControlName="recordedDate" />
            <mat-datepicker-toggle matSuffix [for]="recordedDate"></mat-datepicker-toggle>
            <mat-datepicker #recordedDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.LAST_OCCURRENCE' | translate }}</mat-label>
            <input matInput [matDatepicker]="lastOccurrence" formControlName="lastOccurrence" />
            <mat-datepicker-toggle matSuffix [for]="lastOccurrence"></mat-datepicker-toggle>
            <mat-datepicker #lastOccurrence></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.RECORDER_TYPE">Recorder Type</mat-label>
            <mat-select
              formControlName="recorderResourceType"
              #t
              (ngModelChange)="choseRecorderType(t.value)"
            >
              <mat-option value="Patient">Patient</mat-option>
              <mat-option value="Practitioner">Practitioner</mat-option>
              <mat-option value="RelatedPerson">Related person</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('recorderResourceType', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.ASSERTER_TYPE">Asserter Type</mat-label>
            <mat-select
              formControlName="asserterType"
              #ts
              (ngModelChange)="chooseAsserterType(ts.value)"
            >
              <mat-option value="Patient">Patient</mat-option>
              <mat-option value="Practitioner">Practitioner</mat-option>
              <mat-option value="RelatedPerson">Related person</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('asserterType', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field
            appearance="fill"
            class="mat-form-field-fluid"
            *ngIf="recorderOption != ''"
          >
            <mat-label translate="ALLERGY.INPUT.RECORDER">recorder</mat-label>
            <input
              matInput
              [matAutocomplete]="autoRecorder"
              (ngModelChange)="recorderInputChanged($event, t.value)"
              #recorderInput
              formControlName="recorder"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoRecorder="matAutocomplete"
              (optionSelected)="selectedRecorder($event)"
              [displayWith]="displayFnRecorder"
            >
              <mat-option *ngFor="let recorder of filteredRecorder | async" [value]="recorder">
                {{ getName(recorder, t.value) }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('recorder', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field
            appearance="fill"
            class="mat-form-field-fluid"
            *ngIf="asserterOption != ''"
          >
            <mat-label translate="ALLERGY.INPUT.ASSERTER">Asserter</mat-label>
            <input
              matInput
              [matAutocomplete]="autoAsserter"
              (ngModelChange)="asserterInputChanged($event, ts.value)"
              #asserterInput
              formControlName="asserter"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoAsserter="matAutocomplete"
              (optionSelected)="selectedAsserter($event)"
              [displayWith]="displayFnAsserter"
            >
              <mat-option *ngFor="let asserter of filteredAsserter | async" [value]="asserter">
                {{ getName(asserter, ts.value) }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('asserter', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.NOTE' | translate }}</mat-label>
            <textarea matInput formControlName="note" rows="4"></textarea>
            <mat-error *ngIf="isControlHasError('note', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile headers-in-post-allergy">
          <h4>{{ 'ALLERGY.INPUT.REACTION' | translate }}</h4>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.SUBSTANCE">Substance</mat-label>
            <input
              matInput
              [matAutocomplete]="autoSubstance"
              (ngModelChange)="substanceInputChanged(substanceInput.value)"
              #substanceInput
              formControlName="substance"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoSubstance="matAutocomplete"
              (optionSelected)="selectedSubstance($event)"
            >
              <!--  [displayWith]="displayFnSubstance" -->
              <mat-option *ngFor="let substance of filteredSubstance | async" [value]="substance">
                {{ substance.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('substance', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.MANIFESTATION">Manifestation</mat-label>
            <input
              matInput
              [matAutocomplete]="autoManifestation"
              (ngModelChange)="manifestationInputChanged(manifestationInput.value)"
              #manifestationInput
              formControlName="manifestation"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoManifestation="matAutocomplete"
              (optionSelected)="selectedManifestation($event)"
            >
              <!--  [displayWith]="displayFnManifestation" -->
              <mat-option
                *ngFor="let manifestation of filteredManifestation | async"
                [value]="manifestation"
              >
                {{ manifestation.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('manifestation', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="ALLERGY.INPUT.EXPOSUREROUTE">exposureRoute</mat-label>
            <input
              matInput
              [matAutocomplete]="autoExposureRoute"
              (ngModelChange)="exposureRouteInputChanged(exposureRouteInput.value)"
              #exposureRouteInput
              formControlName="exposureRoute"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoExposureRoute="matAutocomplete"
              (optionSelected)="selectedExposureRoute($event)"
            >
              <!--  [displayWith]="displayFnExposureRoute" -->
              <mat-option
                *ngFor="let exposureRoute of filteredExposureRoute | async"
                [value]="exposureRoute"
              >
                {{ exposureRoute.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('exposureRoute', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.DESCRIPTION' | translate }}</mat-label>
            <textarea matInput formControlName="description" rows="4"></textarea>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'ALLERGY.INPUT.ONSET' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="manifestationOnset"
              formControlName="manifestationOnset"
            />
            <mat-datepicker-toggle matSuffix [for]="manifestationOnset"></mat-datepicker-toggle>
            <mat-datepicker #manifestationOnset></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-8 kt-margin-bottom-20-mobile" style="padding-top: 20px">
          <mat-label class="label-radio-button" translate="ALLERGY.INPUT.SEVERITY"
            >severity</mat-label
          >
          <mat-radio-group formControlName="severity">
            <mat-radio-button value="mild">Mild</mat-radio-button>
            <mat-radio-button value="moderate">Moderate</mat-radio-button>
            <mat-radio-button value="severe">Severe</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="data.animal"
            cdkFocusInitial
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            *ngIf="!isReadOnly"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
